import React, { useState } from 'react';
import { FaRunning, FaWalking, FaHands, FaHandHoldingHeart, FaHeart, FaDumbbell, FaHandPaper, FaUser, FaSmile, FaBrain } from 'react-icons/fa';
import { HiSparkles } from 'react-icons/hi';
import ModuleHeader from "../../moduleHeader";

const defaultPackageData = {
  user: {
    first_name: "Kullanıcı",
    last_name: ""
  },
  package: {
    name: "Body Scan",
    description: "Vücudunuzu tarayarak gerginlikleri fark edin ve rahatlatın. Her bölgeyi sırayla fark edip, kasıp bırakarak gevşetin.",
    image_url: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&q=80"
  }
};

const bodyParts = [
  { id: 1, name: "Ayaklar", icon: FaRunning, description: "Ayaklarınızı fark edin" },
  { id: 2, name: "Bacaklar", icon: FaWalking, description: "Bacaklarınızı fark edin" },
  { id: 3, name: "Kalça", icon: FaHands, description: "Kalça bölgenizi fark edin" },
  { id: 4, name: "Karın", icon: FaHandHoldingHeart, description: "Karın bölgenizi fark edin" },
  { id: 5, name: "Göğüs", icon: FaHeart, description: "Göğüs bölgenizi fark edin" },
  { id: 6, name: "Omuzlar", icon: FaDumbbell, description: "Omuzlarınızı fark edin" },
  { id: 7, name: "Kollar", icon: FaHandPaper, description: "Kollarınızı fark edin" },
  { id: 8, name: "Boyun", icon: FaUser, description: "Boynunuzu fark edin" },
  { id: 9, name: "Yüz", icon: FaSmile, description: "Yüzünüzü fark edin" },
  { id: 10, name: "Kafa", icon: FaBrain, description: "Kafanızı fark edin" }
];

export default function BodyScan({ id, moduleId, isOwner }) {
  const [currentPartIndex, setCurrentPartIndex] = useState(0);
  const [completedParts, setCompletedParts] = useState([]);
  const [isTensing, setIsTensing] = useState(false);
  const [packageData] = useState(defaultPackageData);
  const [isHeaderExpanded, setIsHeaderExpanded] = useState(false);

  const currentPart = bodyParts[currentPartIndex];

  const handleNotice = () => {
    // Sadece fark etme aşaması
  };

  const handleTense = () => {
    setIsTensing(true);
    setTimeout(() => {
      setIsTensing(false);
      handleRelease();
    }, 3000);
  };

  const handleRelease = () => {
    if (!completedParts.includes(currentPart.id)) {
      setCompletedParts([...completedParts, currentPart.id]);
    }
    if (currentPartIndex < bodyParts.length - 1) {
      setTimeout(() => {
        setCurrentPartIndex(currentPartIndex + 1);
      }, 500);
    }
  };

  const handleNext = () => {
    if (currentPartIndex < bodyParts.length - 1) {
      setCurrentPartIndex(currentPartIndex + 1);
    }
  };

  const handleBack = () => {
    if (currentPartIndex > 0) {
      setCurrentPartIndex(currentPartIndex - 1);
    }
  };

  const handleRestart = () => {
    setCurrentPartIndex(0);
    setCompletedParts([]);
    setIsTensing(false);
  };

  const isCompleted = completedParts.length === bodyParts.length;

  return (
    <div className="w-full h-screen min-h-screen flex items-stretch justify-stretch sm:items-center sm:justify-center bg-[#e8e9ed] relative">
      <div className="flex flex-col items-center w-full min-h-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative overflow-y-auto">
        {/* ModuleHeader */}
        <div className="relative z-30 w-full mb-2">
          <ModuleHeader
            userName={packageData.user?.first_name + " " + packageData.user?.last_name}
            subtitle={packageData.package?.name + " Modülüne Hoş Geldiniz"}
            title={packageData.package?.name}
            description={packageData.package?.description}
            backgroundImage={packageData.package?.image_url}
            onExpandedChange={setIsHeaderExpanded}
            showToggle={true}
            autoHeight={true}
          />
        </div>

        <div className="w-full px-6 py-8 pb-24 flex-1">
          {!isCompleted ? (
            <>
              {/* Progress */}
              <div className="mb-8">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs text-gray-400 font-medium">
                    {currentPartIndex + 1} / {bodyParts.length}
                  </span>
                  <span className="text-xs text-gray-400 font-medium">
                    {Math.round(((currentPartIndex + 1) / bodyParts.length) * 100)}%
                  </span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-1">
                  <div 
                    className="bg-[#3DA7B5] h-1 rounded-full transition-all duration-500"
                    style={{ width: `${((currentPartIndex + 1) / bodyParts.length) * 100}%` }}
                  ></div>
                </div>
              </div>

              {/* Current Body Part Card */}
              <div className={`bg-white border rounded-2xl p-8 mb-6 text-center transition-all duration-300 ${
                isTensing ? 'border-[#3DA7B5]' : 'border-gray-200'
              }`}>
                <div className="flex justify-center mb-6">
                  {(() => {
                    const IconComponent = currentPart.icon;
                    return <IconComponent className={`text-7xl transition-colors duration-300 ${
                      isTensing ? 'text-[#3DA7B5]' : 'text-gray-400'
                    }`} />;
                  })()}
                </div>
                <h2 className="text-2xl font-semibold text-gray-800 mb-2">{currentPart.name}</h2>
                <p className="text-gray-500 text-sm mb-8">{currentPart.description}</p>

                {isTensing ? (
                  <div className="space-y-3">
                    <div className="text-lg font-medium text-[#3DA7B5]">Kasıyorsunuz...</div>
                    <div className="text-xs text-gray-400">3 saniye sonra bırakacaksınız</div>
                  </div>
                ) : (
                  <div className="space-y-4">
                    <p className="text-gray-600 text-sm mb-6 leading-relaxed">
                      Şu anda en gergin yeriniz neresi? Orayı fark edin.
                    </p>
                    <button
                      onClick={handleTense}
                      className="w-full bg-[#3DA7B5] hover:bg-[#2F8894] text-white rounded-full py-4 font-medium text-base transition-all duration-300"
                    >
                      Kas ve Bırak
                    </button>
                  </div>
                )}
              </div>

              {/* Navigation */}
              <div className="flex gap-2">
                {currentPartIndex > 0 && (
                  <button
                    onClick={handleBack}
                    className="flex-1 bg-white border border-gray-200 hover:border-gray-300 text-gray-600 hover:text-gray-700 rounded-full py-3 font-medium text-sm transition-all duration-300"
                  >
                    Geri
                  </button>
                )}
                {currentPartIndex < bodyParts.length - 1 && (
                  <button
                    onClick={handleNext}
                    className="flex-1 bg-white border border-gray-200 hover:border-gray-300 text-gray-600 hover:text-gray-700 rounded-full py-3 font-medium text-sm transition-all duration-300"
                  >
                    İleri
                  </button>
                )}
              </div>

              {/* Completed Parts List */}
              {completedParts.length > 0 && (
                <div className="mt-8 pt-6 border-t border-gray-100">
                  <p className="text-xs text-gray-400 mb-3 font-medium">Tamamlanan Bölgeler</p>
                  <div className="flex flex-wrap gap-2">
                    {completedParts.map(partId => {
                      const part = bodyParts.find(p => p.id === partId);
                      const IconComponent = part.icon;
                      return (
                        <span key={partId} className="bg-[#3DA7B5]/10 text-[#3DA7B5] px-3 py-1.5 rounded-full text-xs font-medium flex items-center gap-1.5">
                          <IconComponent className="text-xs" /> {part.name}
                        </span>
                      );
                    })}
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="text-center animate-fadeIn">
              <div className="flex justify-center mb-8">
                <HiSparkles className="text-6xl text-[#3DA7B5]" />
              </div>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Vücut Taraması Tamamlandı</h2>
              <p className="text-gray-500 text-sm mb-8 leading-relaxed">
                Tüm vücudunuzu taradınız ve gerginlikleri rahatlattınız. Kendinizi daha sakin ve gevşemiş hissetmelisiniz.
              </p>
              <button
                onClick={handleRestart}
                className="w-full bg-[#3DA7B5] hover:bg-[#2F8894] text-white rounded-full py-4 font-medium text-base transition-all duration-300"
              >
                Tekrar Başla
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

